import httpClient from '../https-client';

export interface ClassMarkerTestUrlResponse {
  testUrl: string;
}

export interface ClassMarkerStatusResponse {
  status: 'not_registered' | 'in_progress' | 'passed' | 'failed';
  percentage?: number;
  lastAttemptDate?: string;
  pointsEarned?: number;
  pointsAvailable?: number;
  timeTaken?: string;
}

export interface RegisterForExamRequest {
  courseId: string;
}

export const classMarkerApi = {
  registerForExam: async (data: RegisterForExamRequest): Promise<void> => {
    await httpClient.post('/classmarker/register', data);
  },

  getTestUrl: async (courseId: string): Promise<ClassMarkerTestUrlResponse> => {
    const response = await httpClient.get(`/classmarker/test-url/${courseId}`);
    return response.data;
  },

  getTestStatus: async (courseId: string): Promise<ClassMarkerStatusResponse> => {
    const response = await httpClient.get(`/classmarker/status/${courseId}`);
    return response.data;
  },
};
